import type { ApolloCache } from '@apollo/client'

/**
 * Named refetchQueries only reach mounted queries, so pages that are not open
 * would keep showing what they cached. Evicting makes their next mount fetch.
 */
export function evictWorkshopList(cache: ApolloCache<unknown>) {
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'allWorkshops' })
  cache.gc()
}

/**
 * Every cached service plan that pointed at the workshop is left with a dangling
 * reference, which Apollo treats as missing data and fetches again on next read.
 */
export function evictWorkshop(cache: ApolloCache<unknown>, id: string) {
  cache.evict({ id: cache.identify({ __typename: 'WorkshopNode', id }) })
  evictWorkshopList(cache)
}
